import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid } from '@mui/material';

import { add, format } from 'date-fns';
import { mapSubscriptionDurationToMonth } from 'src/utils/format-user-subscription-details';

import { TierReviewSummaryProps } from './types';

export const TierReviewSummary = ({
  tier,
  currencyCode,
  employeeCountToSubscribe,
  amountBilled
}: TierReviewSummaryProps) => {
  const unit =
    tier.duration_months === 1 ? '/ month' : `/ ${tier.duration_months} months`;

  return (
    <Grid container spacing={2} direction="column">
      <Grid item>
        <Typography type="title-md">Review summary</Typography>
      </Grid>
      <Grid item container spacing={5}>
        <Grid item>
          <Typography type="label-sm">Selected Plan</Typography>
          <Typography type="label-lg" aria-label="selected plan">
            {mapSubscriptionDurationToMonth(tier.duration_months)}:{' '}
            {currencyCode} {tier.billed_price} {unit}
          </Typography>
        </Grid>
        <Grid item>
          <Typography type="label-sm">No. of employee</Typography>
          <Typography type="label-lg" aria-label="selected employee count">
            {employeeCountToSubscribe}
          </Typography>
        </Grid>
        <Grid item>
          <Typography type="label-sm">Renewal date</Typography>
          <Typography type="label-lg" aria-label="plan renewal date">
            {format(
              add(new Date(), { months: tier.duration_months }),
              'dd/MM/yyyy'
            )}
          </Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography type="label-sm">Total</Typography>
        <Typography type="title-xl" aria-label="total payable">
          {currencyCode} {amountBilled}{' '}
          <Typography type="title-sm">{unit}</Typography>
        </Typography>
        <Typography type="paragraph-sm">
          Subscription automatically renews on the renewal date
        </Typography>
      </Grid>
    </Grid>
  );
};
